import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-brouillon-transf',
  templateUrl: './brouillon-transf.component.html',
  styleUrls: ['./brouillon-transf.component.scss']
})
export class BrouillonTransfComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
